import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/into-void.jpeg")